module.exports = __webpack_public_path__ + "static/media/05.e3c93754.png";